import React from 'react'
import TextField from 'material-ui/TextField'
import styles from './style'
import PropTypes from 'prop-types'
import { withStyles } from 'material-ui'

const Input = ({
  value,
  onChange,
  onBlur,
  classes,
  meta: { error, touched },
  ...rest
}) => (
  <TextField
    errorText={touched && error}
    value={value}
    onChange={onChange}
    onBlur={onBlur}
    {...rest}

    errorStyle={classes.errorStyle}
    InputProps={{
      classes: {
        root: classes.underlineFocusStyle
      }
    }}
    InputLabelProps={{
      classes: {
        root: classes.floatingLabelFocusStyle
      }
    }}
  />
)

Input.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  meta: PropTypes.object
}

export default withStyles(styles)(Input)


// WEBPACK FOOTER //
// ./src/components/Fields/Input/Input.js